import {createSlice} from '@reduxjs/toolkit'

type EnvType = {
  userAgent: string
  urlOrigin: string
  path: string
  queries: {[key in string]: any}
}

const initialState: EnvType = {
  userAgent: '',
  urlOrigin: '',
  path: '',
  queries: {},
}

export const envSlice = createSlice({
  name: 'env',
  initialState,
  reducers: {
    set(state, action) {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export default envSlice.reducer
